import { GridCellParams } from '@mui/x-data-grid-premium'

export const getNcoCellClassNames = (params: GridCellParams) => {
  const classes: string[] = []

  if (!params?.row?.isParent && params.field === 'onboardingStatus') {
    classes.push('product-status-cell')
  }
  //@ts-ignore
  // if (params.field !== 'total' && params?.rowNode?.isAutoGenerated) classes.push('remove-auto-content')
  // // Hide non-aggregatable cells in the server aggregation row (only show 'total' and 'name')
  // if (params?.row?.isAggregationRow && params.field !== 'total' && params.field !== 'name')
  //   classes.push('remove-auto-content')

  return classes.join(' ')
}
